import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withRouter } from 'react-router';

import classes from '@nerdwallet/base-styles/classes';
import { Link, Text } from '@nerdwallet/currency';

import grnhseTrackingCheck from '../../../lib/company-content-src/grnhse-tracking-check';
import { getJobRelativePath } from '~/client/lib/department-utils';

import styles from './companyJobList.module.less';

const CompanyJobListTile = ({ job, location }) => {
  const relativePath = getJobRelativePath(job);

  return (
    <div className={styles.joblistTileCont}>
      <Link
        href={grnhseTrackingCheck(relativePath, location.search)}
        color="neutral-darkest"
        key={job.title}
      >
        <div
          key={job.id}
          className={classNames([
            'joblistTileInner',
            classes('display-flex'),
            classes('flex-direction-column'),
            classes('flex-direction-row--wide'),
            classes('justify-content-space-between--wide'),
            classes('align-items-center--wide'),
            classes('border-bottom-1'),
            classes('border-neutral-lighter'),
            classes('padding-vertical-3'),
            classes('padding-vertical-4--wide'),
          ])}
        >
          {job.title && (
            <Text size="large" bold>
              {job.title}
            </Text>
          )}
          <div className={styles.joblistTileLocation}>
            <Text size="small">{job.location}</Text>
          </div>
        </div>
      </Link>
    </div>
  );
};

CompanyJobListTile.propTypes = {
  job: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    location: PropTypes.string,
  }),
  location: PropTypes.object,
};

CompanyJobListTile.displayName = 'Company Job List Tile';

const CompanyJobListTileWithRouter = withRouter(CompanyJobListTile);

export default CompanyJobListTileWithRouter;
